function utils() {
  let tooltipRef = null;
  let inputSlideWrapper = null;
  /**
   * This function will be in charge of caching the references
   * to the tooltip and the '.c-input-slide' used by the
   * correct limits function. By caching this elements, we avoid
   * DOM searches (even though querySelector is fast enough) and give
   * a more optimal performance.
   * @param {Element} tooltip
   * @param {Element} inputSlide
   */
  function cacheReferences(tooltip, inputSlide) {
    if (!tooltipRef) {
      tooltipRef = tooltip;
    }
    if (!inputSlideWrapper) {
      inputSlideWrapper = inputSlide;
    }
  }
  /**
 * This function corrects the limits of the tooltip for the noUiSlider.
 * It makes its corrections based on padding instead of translate because
 * the noUiSlider library itself is handling the transform and we do not want
 * to mess with it or overwote it to avoid conflicts. Also, doing css calculations with
 * with transform is much more messy and costly than handling padding and, at the end,
 * it behaves exactly the same and it's also performant.
 * @param {Vue Component} context
 */
  function correctLimits() {
    // Prevent limit correction without the proper references to avoid crashing
    if (!tooltipRef || !inputSlideWrapper) {
      return;
    }
    // Get Bounding Client Rects (Viewport Based)
    const tooltipRect = tooltipRef.getBoundingClientRect();
    const sliderClientRect = inputSlideWrapper.getBoundingClientRect();
    /**
   * The excess left limit and amount has to be calculated based on the
   * slider position and not 0-based because the getBoundingClientRect gets
   * the info based on the viewport so, to avoid weird behaviour, we compare
   * tooltip's x against slider's left position on the viewport. This way, we can
   * get to know if the tooltip exceeded slider's left and by how much.
   */
    const exceedsLeftLimit = tooltipRect.x < sliderClientRect.left;
    const excessLeftAmount = sliderClientRect.left - tooltipRect.x;
    // Left excess limit & amount checks
    if (exceedsLeftLimit && excessLeftAmount > 0) {
      tooltipRef.style.paddingLeft = `${excessLeftAmount}px`;
    } else {
      tooltipRef.style.paddingLeft = 0;
    }
    /**
   * The excess right limit and amount has to be calculated based on the
   * slider's width + left position on the viewport and not based on just width.
   * We sum the tooltip's x position with it's width and check it agains the
   * full slider's width + it's left postion at the viewport
   * (sometimes 0 because it's viewport based),this way, we can obtain if it's
   * exceeding and how much the excess is.
   */
    // eslint-disable-next-line max-len
    const exceedsRightLimit = (tooltipRect.x + tooltipRect.width) > (sliderClientRect.width + sliderClientRect.left);
    // eslint-disable-next-line max-len
    const excessRightAmount = (tooltipRect.x + tooltipRect.width) - (sliderClientRect.width + sliderClientRect.left);
    // Right excess limit & amount checks
    if (exceedsRightLimit && excessRightAmount > 0) {
      tooltipRef.style.paddingRight = `${excessRightAmount}px`;
    } else {
      tooltipRef.style.paddingRight = 0;
    }
  }
  return {
    cacheReferences,
    correctLimits,
  };
}

const sliderUtils = utils();

export default sliderUtils;
